import { FC } from 'react'

import { EuiEmptyPrompt, EuiLoadingContent, EuiPanel, EuiSpacer, EuiTitle } from '@elastic/eui'

export interface TitleComponentProps {
  title: string
}

export interface LoadingComponentProps extends TitleComponentProps {
  excludePanel?: boolean
}

export interface EmptyPromptComponentProps extends TitleComponentProps {
  emptyPromptTitle?: string
  body: string
}

export const TitleComponent: FC<TitleComponentProps> = ({ title }) => {
  return (
    <EuiTitle size='m'>
      <h2>{title}</h2>
    </EuiTitle>
  )
}

export const LoadingComponent: FC<LoadingComponentProps> = ({ title, excludePanel }) => {
  if (excludePanel) {
    return (
      <>
        <TitleComponent title={title} />
        <EuiSpacer size='m' />
        <EuiLoadingContent lines={4} />
      </>
    )
  }

  return (
    <EuiPanel>
      <TitleComponent title={title} />
      <EuiSpacer size='m' />
      <EuiLoadingContent lines={4} />
    </EuiPanel>
  )
}

export const EmptyPromptComponent: FC<EmptyPromptComponentProps> = ({ title, emptyPromptTitle, body }) => {
  return (
    <EuiPanel>
      <TitleComponent title={title} />
      <EuiSpacer size='m' />
      <EuiEmptyPrompt title={<h3>{emptyPromptTitle}</h3>} body={body} />
    </EuiPanel>
  )
}
